import { render, staticRenderFns } from "./DwellingUnitSingleAddressForm.vue?vue&type=template&id=3f01ee5a"
import script from "./DwellingUnitSingleAddressForm.vue?vue&type=script&lang=js"
export * from "./DwellingUnitSingleAddressForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports